/* DEPRECATED
   use graphQL instead
*/

// TODO: check if this file is still used convert it to graphQL and remove if not.

import { AxiosInstance } from 'axios'

export default (axios: AxiosInstance) => {
  return {
    uploadCampaignBannerImage(
      campaignId: number,
      bannerId: number,
      file: File
    ) {
      const formData = new FormData()
      formData.append('image', file)
      return axios
        .post<{ msg: string }>(
          `/campaigns/${campaignId}/banners/${bannerId}/image`,
          formData
        )
        .then(({ data }) => data)
    },
    uploadCampaignEmailImage(campaignId: number, emailId: number, file: File) {
      const formData = new FormData()
      formData.append('image', file)
      return axios
        .post<{ msg: string }>(
          `/campaigns/${campaignId}/emails/${emailId}/image`,
          formData
        )
        .then(({ data }) => data)
    }
  }
}
